import KitchenIcon from "@mui/icons-material/Kitchen";
import AccountBoxIcon from "@mui/icons-material/AccountBox";
import DashboardIcon from '@mui/icons-material/Dashboard';
import { routes } from "../routing/routes";

import BookIcon from '@mui/icons-material/Book';

export const AdminNavTabs = [
  {
    id: "dashboard",
    label: "Dashboard",
    icon: <DashboardIcon sx={{ fontSize: 25 }} />,
    tabUrl: routes.DASHBOARD,
  },
  {
    id: "PpodManagement",
    label: "Pod Management",
    icon: <KitchenIcon sx={{ fontSize: 25 }} />,
    tabUrl: routes.PPOD_MANAGEMENT,
  },
  {
    id: "puserManagement",
    label: "User Management",
    icon: <AccountBoxIcon sx={{ fontSize: 25 }} />,
    tabUrl: routes.PUSER_MANAGEMENT,
  },
];
